// extracted by mini-css-extract-plugin
export default {"root":"TxnHeader_root__S8d7T","scale":"TxnHeader_scale__HUA8u","helper":"TxnHeader_helper__CLMc5"};